export default "__VITE_ASSET__3a9e61c7__"